import { AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, ViewChild, ViewEncapsulation, WritableSignal, afterNextRender, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { FieldType } from "@ngx-formly/core";
import { Product, StoragePlace } from "../../../generated/generated-types";
import { PhxInputQuantityWithWarehouseComponent } from "../../../shared/components/phx-input-quantity-with-warehouse/phx-input-quantity-with-warehouse.component";
import { TransactionModel } from "../../mobile/submodules/mobile-warehouse/components/mobile-manual-stock-transaction-widget/mobile-manual-stock-transaction-widget.component";

type AdditionalTransactionModelFields = {
  productId?: string,
  storagePlace?: StoragePlace,
  storagePlaceId?: string,
};
@Component({
  selector: 'app-input-quantity-with-warehouse',
  templateUrl: './formly-phx-input-quantity-with-warehouse.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PhxInputQuantityWithWarehouseComponent,
    FormsModule,
  ]
})
export class FormlyPhxInputQuantityWithWarehouseComponent extends FieldType implements AfterViewInit {//, ControlValueAccessor {

  private readonly destroyRef = inject(DestroyRef);

  @ViewChild('input')
  input: PhxInputQuantityWithWarehouseComponent;

  product: WritableSignal<Product> = signal(null);
  productId: WritableSignal<string> = signal(null);
  storagePlace: WritableSignal<StoragePlace> = signal(null);
  storagePlaceId: WritableSignal<string> = signal(null);
  serial: WritableSignal<string> = signal(null);
  lotNumber: WritableSignal<string> = signal(null);

  quantity: WritableSignal<number> = signal(null);

  // onChange: (value: number) => void = this.writeValue; // Value Accessor Related
  // onTouch: () => void = () => { }; // Value Accessor Related

  constructor() {
    super();

    afterNextRender({
      read: () => {
        this.form.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x: TransactionModel & AdditionalTransactionModelFields) => {
          x = this.form.getRawValue();
          if (x.product) {
            this.productId.set(null);
            this.product.set(x.product);
          }
          else if (x.productId) {
            this.product.set(null);
            this.productId.set(x.productId);
          }
          else {
            this.product.set(null);
            this.productId.set(null);
          }
          if (x.originStoragePlace) {
            this.storagePlaceId.set(null);
            this.storagePlace.set(x.originStoragePlace);
          }
          else if (x.storagePlace) {
            this.storagePlaceId.set(null);
            this.storagePlace.set(x.storagePlace);
          }
          else if (x.storagePlaceId) {
            this.storagePlace.set(null);
            this.storagePlaceId.set(x.storagePlaceId);
          }
          else if (x.targetStoragePlace) {
            this.storagePlaceId.set(null);
            this.storagePlace.set(x.targetStoragePlace);
          }
          else {
            this.storagePlace.set(null);
            this.storagePlaceId.set(null);
          }
          this.lotNumber.set(x.lotNumber);
          this.serial.set(x.serial);
          this.quantity.set(x.quantity);
          this.input.ngModel.set(x.quantity);
        });
      }
    },);
  }

  ngAfterViewInit(): void {
    this.input.ngModelChange.subscribe((e: number) => {
      if (this.formControl)
        this.formControl.setValue(e);
    });
  }

  //#region Value Accessor Related
  // writeValue(obj: number): void {
  //   this.quantity.set(obj);
  //   this.input.ngModel = obj;
  // }
  // registerOnChange(fn: any): void {
  //   this.onChange = fn;
  // }
  // registerOnTouched(fn: any): void {
  //   this.onTouch = fn;
  // }
  // setDisabledState?(isDisabled: boolean): void {
  //   this.input.disabled = isDisabled;
  // }
  //#endregion
}
